<template>
    <div>
        <!-- Title -->
        <div class="d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer" @click="toggleExpand">
            <span class="font-weight-600">RESOURCES <span v-if="missingResources" class="resources-manager__warning-dot"></span></span>
            <i class="ico mx-0 fs-normal" :class="{'ico-arrow-top':group.resourcesExpanded, 'ico-arrow-bottom':!group.resourcesExpanded}"></i>
        </div>

        <!-- Shown if expanded -->
        <div class="resources-manager__panel-holder" :class="{closed: !group.resourcesExpanded}">
            <!-- Enable / Disable Shared resources -->
            <div v-if="form.availabilityType == 2">
                <div class="d-flex align-items-start">
                    <span>Use these resources for other activities at the same time?</span>
                </div>

                <div class="mt-2 mb-3 fs-small dark">
                    <div class="mt-2 mb-3 flex-shrink-0 fs-small dark">
                        <div class="d-flex" v-if="form.productShareType !== 2">
                            <radio v-model="group.shareType" :value="0" class="d-inline" :disabled="disabled || form.isPrivate == true || form.productShareType == 2" :checked="form.isPrivate == true" >
                                <span class="resources-manager__share-type--limited-width ml-2">NO</span>
                            </radio >              
                        </div>

                        <div class="d-flex mt-2" v-if="form.productShareType !== 2">
                            <radio v-model="group.shareType" :value="1" class="d-inline" :disabled="disabled || form.isPrivate == true || form.productShareType == 2" >
                                <span class="resources-manager__share-type--limited-width ml-2">YES. Products that use the same resource at the same time will share availability. You can set max.seats per product.</span>
                            </radio >
                        </div>

                        <div v-if="form.productShareType == 2">
                            To change this property you need to disable Virtual Roster
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading -->
            <div v-if="availableResources == undefined" class="text-center dark">
                <div>Loading resources please wait</div>
            </div>

            <!-- Got resources, lets show them -->
            <template v-else>
                <div v-if="availableResources && availableResources !== undefined && availableResources.length > 0" class="">
                    <div class="form-group row">
                        <div class="col-sm-12">
                            <table class="table narrow">
                                <thead>
                                    <tr>
                                        <th class="pl-3" style="width: 70%;">Resource</th>
                                        <th class="pl-3" v-if="form.shareType == 2" style="width: 30%;">Max. Seats</th>
                                        <th class="pl-3" v-else style="width: 30%;">Max. Seats</th>
                                        <th class="pl-3" style="width: 50px;">&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(resource, index) in group.resources" :key="resource.id + '-' + index" :class="{'notAllowed': disabled}">
                                        <td class="p-3">
                                            <v-select
                                                v-if="!getLoadingResources"
                                                v-model="group.resources[index]"
                                                :options="resourcesToSelect"
                                                placeholder="- Select resource -"
                                                label="name"
                                                :disabled="disabled"
                                                :class="{'notAllowed': disabled}"
                                                @input="updateResourcesList">
                                            </v-select>

                                            <div v-else>
                                                Loading
                                            </div>
                                        </td>
                                        <td class="pl-3" v-if="form.availabilityType == 2">
                                            <input type="text" style="width: 55px;" class="mr-2" :disabled="disabled" :class="{'border-color-6':resource.invalid}" v-model.number="resource.maxSeats" :max="fetchCapacity(resource)" @input="maxSeatsChanged(resource)" v-numInt> /
                                            <span >{{ fetchCapacity(resource) }}</span>
                                            <span class="color-6 ml-2 fs-smaller" v-if="resource.invalid">Invalid</span>
                                        </td>
                                        <td class="pl-3" v-else>
                                            {{ fetchCapacity(resource) }}
                                        </td>
                                        <td>
                                            <i class="ico-delete largest medium" :class="{'pointer':!disabled, 'notAllowed':disabled}" @click="deleteRow(index, 'resources')"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <span v-if="resourcesToSelect.length == 0 && availableResources.length > 0" class="fs-small dark bold ml-2">All resources used</span>
                            <div v-if="isResourceCapacityBelowFixedLimit" class="fs-small color-6 mb-2 ml-2">
                                The total capacity of the selected resources is below the fixed limit.
                            </div>
                            <div v-if="missingResources" class="fs-small color-6 mb-2 ml-2">
                                If availability is "Limited by resources" you need at least one resource.
                            </div>

                            <div v-if="!readOnly" class="add d-flex align-items-center fs-small bold mt-4 mb-3" :class="{'pointer':!disabled, 'notAllowed':disabled || resourcesToSelect.length == 0, 'opacity-50': resourcesToSelect.length == 0}" @click="addResource">
                                <i class="ico-add fs-smallest add-circle color-1"></i> Add resource
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="availableResources && availableResources.length == 0" class="text-center dark">
                    <div>⛵  You have no resources, let's add one to your inventory.</div>
                    <button type="button" class="btn mt-3" @click="createResource" :disabled="disabled">Create Resources</button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { eventFormStateHelper } from '@/store/helpers/eventFormStateHelper'
    import { eventHub } from '@/main'

    import extendedVSelect from '@/extends/vue-select'
    import { AvailabilityTypes } from '@/enums/productAvailabilityTypes'

    export default {
        data() {
            return {
                haveUserCreatedNewResource: 0,
            }
        },
        props: {
            form: {
                default: null
            },
            group:{
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            readOnly: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            // Validates each resource during component assembly
                this.group.resources.forEach((resource) => {
                this.maxSeatsChanged(resource);
            });
        },
        created() {
            this.initResources();
            //add listener to resource change (when user have no resources and uses te modal to create), we than update the available resurces
            eventHub.$on('updatedResources', event => {
                this.haveUserCreatedNewResource++;
            });
        },
        computed: {
            ...mapGetters([
                'account',
                'getResources',
                'getLoadingResources'
            ]),
            availableResources() {
                return this.getResources;
            },
            resourcesToSelect() {
                return this.availableResources.filter(availableResource => {
                    let foundUsedResource = this.group.resources.find(usedResource => {return usedResource.id == availableResource.id})
                    return (!foundUsedResource)? true : false
                });
            },
            totalResourcesCapacity() {
                const list = this.group.resources ? this.group.resources : [];
                return list.reduce((sum, resource) => {
                    const cap = resource.availability;
                    return sum + cap;
                }, 0);
            },
            fixedLimitCapacity() {
                return this.form.capacity;
            },
            isResourceCapacityBelowFixedLimit() {
                if (this.form.availabilityType !== AvailabilityTypes.FIXED_LIMIT) {
                    return false;
                }

                const hasResources = this.group.resources && this.group.resources.length > 0;
                return !!(hasResources && this.totalResourcesCapacity < this.fixedLimitCapacity);
            },
            missingResources() {
                return this.form.availabilityType === AvailabilityTypes.LIMITED_BY_RESOURCES && (!this.group.resources || this.group.resources.length === 0);
            }
        },
        methods: {
            ...mapActions([
                'openModal',
                'initResources',
                'setCreatingNewResource'
            ]),
            ...eventFormStateHelper.mapActions([
                'setHasResourceErrors'
            ]),
            createEmptyResourceRow() {
                let resourceToCopy = this.resourcesToSelect[0];
                this.setMaxSeats(resourceToCopy);
                return resourceToCopy;
            },
            updateResourcesList(resource) {
                this.setMaxSeats(resource);
                // After selecting a resource, re-evaluate validity and update Vuex
                const anySeatCapacityExceeded = this.group.resources && this.group.resources.some(resource => resource.maxSeats > this.fetchCapacity(resource));
                this.setHasResourceErrors(anySeatCapacityExceeded);
            },
            fetchCapacity(item) {
                return item ? item.availability : '-';
            },
            deleteRow(row, item) {
                if (this.disabled) {
                    return false;
                }

                const deleteItem = () => {
                    if (item === 'resources' && this.group.resources) {
                        this.group.resources.splice(row, 1);
                    }
                };

                if (this.group.passengerSettings && this.group.availabilityType === 2) {
                    this.$dialog
                        .confirm(`
                            <div class="fs-larg font-weight-600 mb-4">Remove resource?</div>
                            <div>You have availability depending on resources, are you sure you want to continue?</div>
                        `)
                        .then(() => deleteItem())
                        .catch(() => {});
                } else {
                    deleteItem();
                }
            },
            createResource() {
                this.setCreatingNewResource(true); // we are creating new, not editing existing one
                this.openModal('ResourceAdd');
            },
            addResource() {
                if (this.disabled || this.resourcesToSelect.length == 0) {
                    return false;
                }

                if (this.group.resources === undefined) {
                    this.$set(this.group, 'resources', []);
                }
                this.group.resources.push(this.createEmptyResourceRow()); // ok
                this.$forceUpdate(); //fixes this: https://vuejs.org/v2/guide/list.html#Array-Change-Detection
                // After adding a resource, update Vuex validity (new rows are initialized to valid maxSeats)
                const anySeatCapacityExceeded = this.group.resources && this.group.resources.some(resource => resource.maxSeats > this.fetchCapacity(resource));
                this.setHasResourceErrors(anySeatCapacityExceeded);
            },
            toggleExpand() {
                if (!this.group.resourcesExpanded) {
                    this.$set(this.group, 'resourcesExpanded', true);
                } else {
                    this.group.resourcesExpanded = !this.group.resourcesExpanded;
                }
            },
            setMaxSeats(resource) {
                if (!resource.maxSeats) {
                    this.$set(resource, 'maxSeats', this.fetchCapacity(resource));
                }
            },
            maxSeatsChanged(resource) {
                const isInvalid = resource.maxSeats > this.fetchCapacity(resource);
                this.$set(resource, 'invalid', isInvalid);
                this.setHasResourceErrors(isInvalid);
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
   .resources-manager {
        &__panel-holder {
            &.closed {
                max-height: 0;
                overflow: hidden;
            }
        }

        &__share-type--limited-width {
            max-width: 88%;
        }

        &__warning-dot {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #e74c3c;
            margin-left: 0.5rem;
            vertical-align: middle;
        }
    }

    table {
        tr {
            th, td {
                vertical-align: middle;
            }
        }
    }

    .table {
        tbody tr:hover {
            border: none;
            transform: none;
        } 
    }
</style>



// WEBPACK FOOTER //
// ResourcesManager.vue?298b42cd